import {useWindowSize} from '@wandb/weave/common/hooks/useWindowSize';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import React from 'react';

import {trackAddPanels} from '../../services/analytics/addPanelsEvents';
import {type Ref as PanelBankSectionConfigRef} from '../../state/views/panelBankSectionConfig/types';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawer/WorkspaceDrawerContextProvider';

type AddPanelsDrawerButtonProps = {
  targetSectionRef?: PanelBankSectionConfigRef;
};

export const AddPanelsDrawerButton = ({
  targetSectionRef,
}: AddPanelsDrawerButtonProps) => {
  const {responsiveSize} = useWindowSize();
  const {openWorkspaceDrawer} = useWorkspaceDrawerContext();

  if (responsiveSize === 'small') {
    return null;
  }

  const scope = targetSectionRef ? 'section' : 'global';

  return (
    <Button
      data-test={`add-vis-${scope}`}
      className="add-vis-button"
      twWrapperStyles={{display: 'block'}}
      variant={targetSectionRef ? 'ghost' : 'primary'}
      icon="add-new"
      onClick={() => {
        openWorkspaceDrawer('add-panels', targetSectionRef);
        trackAddPanels({
          action: 'Drawer opened',
          scope,
        });
      }}>
      Add panels
    </Button>
  );
};
